document.addEventListener('DOMContentLoaded', () => {
    const productsWrapper = document.querySelector('#recommended-products-wrapper');
    if (productsWrapper) {
        productsWrapper.classList.remove('hidden');
    }

    const slickElement = $('.products-slick .slick');
    if (slickElement.length) {
        slickElement.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            mobileFirst: true,
            prevArrow: $('.recommended-products .products-slick .arrow-left'),
            nextArrow: $('.recommended-products .products-slick .arrow-right'),
            responsive: [
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                }
            ]
        });
    }
});
